import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-66d082e3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "actions-section",
  class: "actions-section"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_filter_section_title = _resolveComponent("filter-section-title");
  const _component_b_button = _resolveComponent("b-button");
  const _component_flex_row = _resolveComponent("flex-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.changes ? (_openBlock(), _createBlock(_component_filter_section_title, {
    key: 0,
    title: $options.title,
    count: $options.isObject ? $props.changes.count : 0,
    showCount: $options.isObject,
    color: "#2172E1",
    countColor: "#2172E1"
  }, null, 8, ["title", "count", "showCount"])) : _createCommentVNode("", true), _createVNode(_component_flex_row, {
    gap: 8,
    classes: "buttons"
  }, {
    default: _withCtx(() => [_createVNode(_component_b_button, {
      variant: "outline-primary",
      size: "sm",
      class: "discard-button",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('discard'))
    }, {
      default: _withCtx(() => [_createTextVNode(" Discard ")]),
      _: 1
    }), _createVNode(_component_b_button, {
      variant: "primary",
      size: "sm",
      class: "apply-button",
      disabled: !$props.isModified,
      onClick: _cache[1] || (_cache[1] = () => {
        _ctx.$emit('apply');
        _ctx.$emit('closeDropdown');
      })
    }, {
      default: _withCtx(() => [_createTextVNode(" Apply ")]),
      _: 1
    }, 8, ["disabled"])]),
    _: 1
  })]);
}